import React, {
  useState
}                          from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  createPartner,
  showPartner,
}                           from '~/config/routes';
import Request              from '~/providers/Request';
import PartnerRecord        from '~/records/PartnerRecord';
import Form                 from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new PartnerRecord());
  const [ loading, setLoading ] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams({doctor: true});

    Request.post('/admin/partner', data, {}, { controller: 'partner' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(createPartner.spec);
        } else{
          history.push(showPartner.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
